<template>
  <section>
    <results-top-bar />
    <ul class="results-cars">
      <car-item v-for="car in carList" :key="car.pk" :car-data="car" />
    </ul>
    <show-more-button />
  </section>
</template>

<script>
import ResultsTopBar from "@/components/results/ResultsTopBar/ResultsTopBar.vue";
import CarItem from "@/components/results/CarItem/CarItem.vue";
import ShowMoreButton from "@/components/results/ShowMoreButton/ShowMoreButton.vue";
import { GET_DATA_FROM_API } from "@/store/actionTypes";

export default {
  name: "Results",
  metaInfo() {
    return {
      title: this.$t("meta-info.title.results")
    };
  },
  components: {
    ResultsTopBar,
    CarItem,
    ShowMoreButton
  },
  computed: {
    carList() {
      return this.$store.state.results.carList;
    }
  },
  mounted() {
    !this.$store.state.results.carList.length &&
      this.$store.dispatch(GET_DATA_FROM_API);
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: $media-l) {
  .results-cars {
    @include grid-columns(2);
    @include grid-ie11-fix(2);

    grid-gap: 30px;
    margin-bottom: 30px;
  }
}

@media screen and (min-width: $media-xl) {
  .results-cars {
    @include grid-columns(3);
    @include grid-ie11-fix(3);
  }
}

@media screen and (min-width: $media-xxxl) {
  .results-cars {
    @include grid-columns(4);
    @include grid-ie11-fix(4);
  }
}
</style>
